// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.languages {
  float: right;
  text-align: right;
  font-weight: normal;
  font-size: 12px;
  width: 92px;
  margin-top: 16px;
}
.languages a,
.languages span {
  color: #9e9e9e;
  margin-left: 8px;
  text-decoration: none;
}
.languages a:hover,
.languages a:focus {
  text-decoration: underline;
}
.languages span {
  color: #757575;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/less/l10n.less"],"names":[],"mappings":"AAGA;EACC,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAFD;AAJA;;EASE,cAAA;EACA,gBAAA;EACA,qBAAA;AADF;AAKE;;EACC,0BAAA;AAFH;AAdA;EAoBE,cAAA;EACA,gBAAA;AAHF","sourcesContent":["@import (reference) \"../../../less/variables\";\n@import (reference) \"../../../less/mixins\";\n\n.languages {\n\tfloat: right;\n\ttext-align: right;\n\tfont-weight: normal;\n\tfont-size: @tsXSmall;\n\twidth: @gutter*11.5;\n\tmargin-top: @gutter*2;\n\n\ta, span {\n\t\tcolor: @tSecondaryLight;\n\t\tmargin-left: @gutter;\n\t\ttext-decoration: none;\n\t}\n\ta {\n\n\t\t&:hover, &:focus {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n\tspan {\n\t\tcolor: @tSecondary;\n\t\tfont-weight: @twSemi;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
